<div class="modal-header-block title">
  @if (!isEdit) {
    <button class="modal-back-btn-icon" (click)="activeModal.close({ action: 'EDIT' })">
      <rkt-icon name="arrow-left"></rkt-icon>
    </button>
  }

  <h2>{{ isEdit ? 'Edit Document' : 'Upload Document' }}</h2>

  <button class="close-button" (click)="activeModal.close()"><rkt-icon name="times"></rkt-icon></button>
</div>

<div class="document-type">
  <rkt-icon [name]="documentTypeData.icon"></rkt-icon>
  {{ documentTypeData.label }}
</div>

<div class="details-page-edit-form integrated-bank-account-form">
  <form [formGroup]="documentForm">
    <rkt-form [form]="documentForm" [fields]="documentFields" [model]="formModel"></rkt-form>
  </form>

  @if (isTwoSided) {
    <div class="file-drop-label">Front</div>
  }
  <div class="file-drop">
    <app-file-upload
      [title]="isTwoSided ? 'Drag & drop the front image here' : 'Drag & drop files here'"
      [fileTypes]="['image/jpeg', 'image/png', 'application/pdf']"
      [uploadedFileLabel]="formModel.isFileUploaded ? documentTypeData.label : undefined"
      (selectedFile)="onFileUploaded($event)"
    ></app-file-upload>
  </div>

  @if (isTwoSided) {
    <div class="file-drop-label">Back</div>
    <div class="file-drop">
      <app-file-upload
        title="Drag & drop the back image here"
        [fileTypes]="['image/jpeg', 'image/png', 'application/pdf']"
        [uploadedFileLabel]="isBackFileUploaded ? documentTypeData.label : undefined"
        (selectedFile)="onBackFileUploaded($event)"
      ></app-file-upload>
    </div>
  }

  <div class="buttons">
    <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Cancel</button>
    <button
      rktButton
      type="submit"
      (click)="onSubmit()"
      [disabled]="isLoading || !(documentForm.valid && isUploadReady)"
      [title]="isEdit ? 'Save' : 'Upload'"
    >
      {{ isEdit ? 'Save' : 'Upload' }}
    </button>
  </div>
</div>
